import { useCallback, useSyncExternalStore } from 'react'
import { getPreferenceEntry, type PreferenceKey, type PreferenceValue } from './registry'
import { getValue, setValue, subscribe } from './preferencesStore'

// Reactive read/write for a single preference. Built on useSyncExternalStore
// (the same precedent as useTier) so any component — the Settings page or a
// future inline density control on a table — reads and writes the ONE stored
// value. getValue returns a primitive, so the snapshot is referentially stable.
export function usePreference(
  key: PreferenceKey,
): [PreferenceValue, (value: PreferenceValue) => void] {
  const value = useSyncExternalStore(
    subscribe,
    () => getValue(key),
    () => getPreferenceEntry(key).default,
  )
  const set = useCallback((v: PreferenceValue) => setValue(key, v), [key])
  return [value, set]
}
